import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\GetPersonByIdWithAllRelationsController::__invoke
* @see app/Http/Controllers/Person/GetPersonByIdWithAllRelationsController.php
* @route '/api/person/{mergeablePerson}/relations'
*/
const GetPersonByIdWithAllRelationsController = (args: { mergeablePerson: string | number | { id: string | number } } | [mergeablePerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPersonByIdWithAllRelationsController.url(args, options),
    method: 'get',
})

GetPersonByIdWithAllRelationsController.definition = {
    methods: ["get","head"],
    url: '/api/person/{mergeablePerson}/relations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Person\GetPersonByIdWithAllRelationsController::__invoke
* @see app/Http/Controllers/Person/GetPersonByIdWithAllRelationsController.php
* @route '/api/person/{mergeablePerson}/relations'
*/
GetPersonByIdWithAllRelationsController.url = (args: { mergeablePerson: string | number | { id: string | number } } | [mergeablePerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { mergeablePerson: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { mergeablePerson: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            mergeablePerson: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        mergeablePerson: typeof args.mergeablePerson === 'object'
        ? args.mergeablePerson.id
        : args.mergeablePerson,
    }

    return GetPersonByIdWithAllRelationsController.definition.url
            .replace('{mergeablePerson}', parsedArgs.mergeablePerson.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\GetPersonByIdWithAllRelationsController::__invoke
* @see app/Http/Controllers/Person/GetPersonByIdWithAllRelationsController.php
* @route '/api/person/{mergeablePerson}/relations'
*/
GetPersonByIdWithAllRelationsController.get = (args: { mergeablePerson: string | number | { id: string | number } } | [mergeablePerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPersonByIdWithAllRelationsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Person\GetPersonByIdWithAllRelationsController::__invoke
* @see app/Http/Controllers/Person/GetPersonByIdWithAllRelationsController.php
* @route '/api/person/{mergeablePerson}/relations'
*/
GetPersonByIdWithAllRelationsController.head = (args: { mergeablePerson: string | number | { id: string | number } } | [mergeablePerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPersonByIdWithAllRelationsController.url(args, options),
    method: 'head',
})

export default GetPersonByIdWithAllRelationsController